/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_InvalidInputs */

const en_error_passkey_invalid = /** @type {(inputs: Error_Passkey_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That passkey wasn't accepted. Try again, or use another way to sign in.`)
};

/**
* | output |
* | --- |
* | "That passkey wasn't accepted. Try again, or use another way to sign in." |
*
* @param {Error_Passkey_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_passkey_invalid = /** @type {((inputs?: Error_Passkey_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_passkey_invalid(inputs)
});